import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import unescape from "lodash/unescape";
import environment from "web/script/modules/environment";

const initialValues = environment.get("showMoreButton");

export interface FeedsShowMoreSlice {
    currentPage: number | null;
    visibleProductCount: number;
    totalProductCount: number;
    showMoreNextUrl: string;
    showMoreText: string;
    isLoading: boolean;
    remainingProducts: number;
}

interface NextPagePayload {
    currentPage: number;
    showMoreNextUrl: string;
    visibleProductCount: number;
    totalProductCount: number;
}

let initialState: FeedsShowMoreSlice = {
    currentPage: null,
    visibleProductCount: 0,
    totalProductCount: 0,
    showMoreNextUrl: "",
    showMoreText: "",
    isLoading: false,
    remainingProducts: 0,
};

if (initialValues) {
    initialState.currentPage = initialValues.current_page;
    initialState.showMoreNextUrl = unescape(initialValues.show_more_next_url);
    initialState.showMoreText = initialValues.show_more_text;
    initialState.totalProductCount = initialValues.total_product_count;
    initialState.visibleProductCount = initialValues.visible_product_count;
    initialState.remainingProducts = initialValues.remaining_product_count;
}

const feedsShowMore = createSlice({
    name: "feedsShowMore",
    initialState,
    reducers: {
        setAll(state, action: PayloadAction<FeedsShowMoreSlice>): void {
            state.currentPage = action.payload.currentPage;
            state.showMoreNextUrl = action.payload.showMoreNextUrl;
            state.totalProductCount = action.payload.totalProductCount;
            state.visibleProductCount = action.payload.visibleProductCount;
            state.showMoreText = action.payload.showMoreText;
            state.remainingProducts = action.payload.remainingProducts;
            state.isLoading = false;
        },
        setNextPage(state, action: PayloadAction<NextPagePayload>): void {
            state.currentPage = action.payload.currentPage;
            state.showMoreNextUrl = action.payload.showMoreNextUrl;
            state.visibleProductCount = action.payload.visibleProductCount;
            state.totalProductCount = action.payload.totalProductCount;
            state.isLoading = false;
        },
        setLoading(state, action: PayloadAction<boolean>): void {
            state.isLoading = action.payload;
        },
    },
});

const { actions, reducer } = feedsShowMore;
export const { setAll, setNextPage, setLoading } = actions;
export default reducer;
